import React from "react";

interface Props {
  className?: string;
}

const IconMenu: React.FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 448 512">
    <path
      d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
      fill="currentColor"
    />
  </svg>
);

export default IconMenu;
